import React from 'react';
import {
    Segment,
    Table,
    Header,
    Form,
    Button,
    Select,
    Input
} from 'semantic-ui-react';


/* props:
editMode bool, contactTypes array, onAddNewContact fn, onDeleteContact fn, contacts array
*/

// in student create, contacts are added and changed locally, so onAddNewContact and onDeleteContact
// need to append their own ids for this component to know on which contacts to call delete.
export default class ContactFormSegment extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            contacts: [],

            value: null,
            contactType: null,
            comment: null,

            valueError: false,
            contactTypeError: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.getContacts = this.getContacts.bind(this);
    }

    componentDidMount() {
        this.getContacts();
    }

    componentWillReceiveProps(nextProps) {
        console.log('Novi props: ', nextProps.contacts);
        this.setState({
            contacts: nextProps.contacts,
        });
    }


    getContacts() {
        const { contacts } = this.props;

        this.setState({
            contacts
        });
    }

    onAddNewContact() {
        const {
            value,
            contactType,
        } = this.state;

        if ((value === null || value === '') || contactType === null) {
            this.setState({
                valueError: value === null || value === '',
                contactTypeError: contactType === null,
            });

            return;
        }

        const contact = {
            value: this.state.value,
            contactType: { id: this.state.contactType },
            comment: this.state.comment,
        };

        this.props.onAddNewContact(contact);
        this.resetValues();
    }

    resetValues() {
        this.setState({
            value: '',
            contactType: null,
            comment: null,

            valueError: false,
            contactTypeError: false,
        });
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });
    }
    render() {
        console.log('Kontakti: ', this.props.contacts);
        const { contacts } = this.state;
        console.log('Kontakti iz State: ', contacts);
        return (
            <React.Fragment>
                { !!contacts.length && <Segment>
                    <Table compact size="small" celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Tip</Table.HeaderCell>
                                <Table.HeaderCell>Kontakt</Table.HeaderCell>
                                {/* <Table.HeaderCell></Table.HeaderCell> */}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {contacts.map(el =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell>
                                        {!!el.contactType && el.contactType.name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {el.value}
                                    </Table.Cell>
                                    {/* <Table.Cell verticalAlign="middle" className="text-center"> */}
                                    {/*    <Button */}
                                    {/*        basic */}
                                    {/*        color="red" */}
                                    {/*        size="mini" */}
                                    {/*        onClick={() => this.props.onDeleteContact(el.id)} */}
                                    {/*    > */}
                                    {/*        Arhiviraj */}
                                    {/*    </Button> */}
                                    {/* </Table.Cell> */}
                                </Table.Row>))}
                        </Table.Body>
                    </Table>
                </Segment>}
                { this.props.editMode && <Segment>
                    <Header as="h5">Dodaj novi kontakt</Header>
                    <Form noValidate>
                        <Form.Group widths="equal">
                            <Form.Field
                                control={Select}
                                clearable
                                value={this.state.contactType}
                                options={this.props.contactTypes}
                                placeholder="Tip kontakta"
                                onChange={this.handleInputChange}
                                name="contactType"
                                required
                                error={this.state.contactTypeError}
                            />
                            <Form.Field
                                control={Input}
                                onChange={this.handleInputChange}
                                placeholder="Vrijednost"
                                value={this.state.value}
                                name="value"
                                required
                                error={this.state.valueError}
                            />
                            <Button primary onClick={this.onAddNewContact}>Dodaj</Button>
                        </Form.Group>
                    </Form>
                </Segment>}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderContactEditable.js